import React, { useEffect, useMemo, useState } from 'react';
import { useAppDispatch } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
// Components
import PaymentContainer from 'components/PaymentContainer/PaymentContainer';
import MakePaymentHeading from './components/MakePaymentHeading/MakePaymentHeading';
import PaymentAmount from './components/PaymentAmount/PaymentAmount';
import DebtSection from './components/DebtSection/DebtSection';
// Const and utils
import { DirectPaymentStage } from 'common/consts/directpaymentstages';
import {
  IPaymentAmountFormModel,
  IVerifyIdentityFormModel,
} from 'features/payment/types';
import http from 'app/http';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import { setContent } from 'features/content/reducer';
import { UrlEncodedHeaders } from 'features/payment/services';
import styles from './DirectPaymentPageData.module.scss';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getGTMVariables, getGTMVariablesPageView  } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import TechnicalErrorPopup from 'components/TechnicalErrorPopup/TechnicalErrorPopup';
import classNames from 'classnames/bind';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const DirectPaymentPagedata = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [verifyIdentity, setVerifyIdentity] =
    useState<IVerifyIdentityFormModel>({});
  const currentStage = useMemo(() => {
    return Model?.Stage;
  }, [Model]);  
  const [showPayButton, setShowPayButton] = useState<boolean>(false);
  const isUserAuthenticated = useMemo(() => {
    return Model?.IsUserAuthenticated;
  }, [Model]);
  const [showTechnicalErrorPopup, setShowTechnicalErrorPopup] = useState(
    Model?.FormModel?.VerifyIdentityFormModel?.GenericServiceError
  );

  useEffect(() => {
    if(!isUserAuthenticated && (Model?.Stage === DirectPaymentStage.VerifyIdentity))       
    {
      LoggedOutPaymentStep1Tracking();
    } 
        
  }, [Model?.Stage]);

  
  useEffect(() => {
    let tagManagerArgs:any;
    if(showPayButton)       
    {
      if(!isUserAuthenticated)
      {
       tagManagerArgs = {
        dataLayer: {
          event: "checkout_step", 
          checkout_name : "Single Payment - Logged Out", 
          checkout_step_number : "2"}
        };
      
      TagManager.dataLayer(tagManagerArgs);
      }
      else
      {
        tagManagerArgs = {
          dataLayer: {
            event: "checkout_step", 
            checkout_name : "Single Payment - Logged In", 
            checkout_step_number : "1",
            is_secured_user: LayoutModel?.IsLoggedInUserSecured,
          ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} )          
          }
          };
        
        TagManager.dataLayer(tagManagerArgs);
      }
    } 
        
  }, [showPayButton]);

  const LoggedOutPaymentStep1Tracking = () => {
    var tagManagerArgs = {
      dataLayer: {
        event: "checkout_step", 
        checkout_name : "Single Payment - Logged Out", 
        checkout_step_number : "1",
      }
      };
    
    TagManager.dataLayer(tagManagerArgs);
  }

 
  const onVerifyIdentity = async (data: any) => {
    // Keep form data in local state
    setVerifyIdentity(data);
    //Get pathname from url
    const verifyIdentityUrl = getPathnameFromUrl(
      Model?.Links?.PostVerifyIdentityPageUrl,
    );
    // Verification request
    try {
      const response = await http.post(
        verifyIdentityUrl,
        qs.stringify({ FormModel: data }),
        UrlEncodedHeaders,
      );
      if (response) {        
        dispatch(setContent({ [verifyIdentityUrl]: response.data }));
        history.push(verifyIdentityUrl, { noRefresh: true });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onSetAmount = async (data: IPaymentAmountFormModel) => {
    try {
      const { VerifyIdentityFormModel } = verifyIdentity;
      const payload = isUserAuthenticated
        ? data
        : {
            ...data,
            VerifyIdentityFormModel,
          };
      const response = await http.post(
        Model?.Links?.PostSetAmountPageUrl,
        // Convert object into string
        qs.stringify({ FormModel: payload }),
        UrlEncodedHeaders,
      );
      if (response && response.data) {
        // Display Adyen widget if payment session is open
        if (response.data.Model.AdyenForm?.IsPaymentSessionOpen) {          
          setShowPayButton(true);
        } else {
          setShowPayButton(false);
        }
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        const nextPagePath = getPathnameFromUrl(
          Model?.Links?.PostSetAmountPageUrl,
        );
        // Add response to store
        dispatch(setContent({ [nextPagePath]: response.data }));
        // Redirect to next step path
        history.push(nextPagePath, {
          noRefresh: true,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

    useEffect(() => {
      setShowTechnicalErrorPopup(
        Model?.FormModel?.VerifyIdentityFormModel?.GenericServiceError,
      );
    }, [Model]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {!isUserAuthenticated &&
          currentStage === DirectPaymentStage.VerifyIdentity && (
            <div className={styles.section}>
              <MakePaymentHeading
                Header={PageData?.Header}
                HeaderText={PageData?.HeaderText}
              />              

            </div>
          )}

        {currentStage === DirectPaymentStage.VerifyIdentity && (
          <>
            {Model?.FormModel?.VerifyIdentityFormModel?.IsDisableRecaptcha ? (
              <DebtSection {...props} onVerifyIdentity={onVerifyIdentity} />
            ) : (
              <GoogleReCaptchaProvider reCaptchaKey={Model?.ReCaptchaKey}>
                <DebtSection {...props} onVerifyIdentity={onVerifyIdentity} />
              </GoogleReCaptchaProvider>
            )}
          </>
        )}
      </div>
      {(Model?.Stage === DirectPaymentStage.ChoosePaymentAmount ||
        Model?.Stage === DirectPaymentStage.PaymentDetails) && (
        <div className={styles.section}>
          <PaymentAmount {...props} onChangeAmount={onSetAmount} />
        </div>
      )}

      {((Model?.Stage !== DirectPaymentStage.VerifyIdentity) || (Model?.IsPayFullBalance)) && (
        <>
          <div className={styles.heading_wrapper}>
            <div className={styles.heading}>
              {PageData?.HowWouldLiketoPayLabel}
            </div>
          </div>
          <PaymentContainer
            Model={Model}
            PageData={PageData}
            IsDirectPayment={true}
            showPayButton={showPayButton}
          />
        </>
      )}
      <div
        className={classNames(
          'modal-overlay',
          showTechnicalErrorPopup ? 'is-active' : '',
        )}
      >
        <TechnicalErrorPopup
          Model={Model}
          PageData={PageData}
          LayoutModel={LayoutModel}
          onClose={() => setShowTechnicalErrorPopup(false)}
        />
      </div>
    </div>
  );
};

export default DirectPaymentPagedata;
